import { render } from "./createRole.vue?vue&type=template&id=59de5b52&scoped=true"
import script from "./createRole.vue?vue&type=script&lang=js"
export * from "./createRole.vue?vue&type=script&lang=js"

import "./createRole.vue?vue&type=style&index=0&id=59de5b52&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59de5b52"]])

export default __exports__